import React, { createContext, useCallback, useState } from 'react';

interface UIContextProps {
  sideBarOpen: boolean;
  toggleSidebar: () => void;
}

const UIContext = createContext<UIContextProps | undefined>(undefined);

type UIProviderProps = { children: React.ReactNode };
export const UIProvider = ({ children }: UIProviderProps) => {
  const [sideBarOpen, setSidebarOpen] = useState<boolean>(true);
  const toggleSidebar = useCallback(() => {
    setSidebarOpen((isOpen) => {
      return !isOpen;
    });
  }, []);
  return <UIContext.Provider value={{ sideBarOpen, toggleSidebar }}>{children}</UIContext.Provider>;
};

export const useUIContext = () => {
  const context = React.useContext(UIContext);
  if (context === undefined) {
    throw new Error('useMetaReducer must be used within a MetaProvider');
  }
  return context;
};
